import React, { useState } from 'react';

// MUI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const StyledIcon = styled(Icon)(() => ({
  fontSize: '1.2rem',
  verticalAlign: 'middle',
  marginRight: '5px'
}));
const StyledModal = styled(Modal)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  bottom: '10rem',
  transform: 'translate(-50%, -50%)',
  width: 400,
  backgroundColor: theme.palette.common.white,
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
}));

const StyledPopupList = styled(List)(({ theme }) => ({
  marginTop: '10px',
  marginBottom: '10px',
  minWidth: '200px',
  paddingTop: '2px',
  paddingBottom: '2px',
  fontSize: '12px',
  paddingLeft: theme.spacing(2),
  listStylePosition: 'inside',
  display: 'block'
}));

const PlusIconModalTrigger = ({ setOpen, size }) => {
  return (
    <Button sx={{ background: 'none' }} size='small' onClick={() => setOpen(true)}>
      <StyledIcon>
        <Icon sx={{ fontSize: '0.8rem' }}>add</Icon>
        {size}
      </StyledIcon>
    </Button>
  );
};

const ColumnWithPopup = ({ contentArray = [''], modalHeaderLabel }) => {
  const [open, setOpen] = useState(false);
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box sx={{ mr: 1 }}>{contentArray[0]}</Box>
      <Box sx={{ display: { xs: 'none', md: 'inherit' }, verticalAlign: 'middle' }}>
        {contentArray.length > 1 && (
          <Tooltip
            title={
              <StyledPopupList>
                {contentArray.slice(1).map((item, index) => (
                  <ListItem
                    sx={{ listStyleType: 'disc', display: 'list-item', pl: 2 }}
                    key={`${index}-${item}`}
                  >
                    {item}
                  </ListItem>
                ))}
              </StyledPopupList>
            }
            placement='bottom'
          >
            <>
              <StyledIcon>add</StyledIcon>
              <span>{contentArray.length - 1}</span>
            </>
          </Tooltip>
        )}
      </Box>
      <Box sx={{ display: { xs: 'inherit', md: 'none' } }}>
        {contentArray.length > 1 && (
          <PlusIconModalTrigger setOpen={setOpen} size={contentArray.length - 1} />
        )}
        <StyledModal open={open} onClose={() => setOpen(false)}>
          <Box>
            <Typography variant='h6' component='h2'>
              {modalHeaderLabel}
            </Typography>
            <StyledPopupList>
              {contentArray.slice(1).map((item, index) => (
                <ListItem key={`${index}-${item}`}>{item}</ListItem>
              ))}
            </StyledPopupList>
          </Box>
        </StyledModal>
      </Box>
    </Box>
  );
};

export default ColumnWithPopup;
